import { render, staticRenderFns } from "./navHeader.vue?vue&type=template&id=e304b8fe&scoped=true"
import script from "./navHeader.vue?vue&type=script&lang=js"
export * from "./navHeader.vue?vue&type=script&lang=js"
import style0 from "./navHeader.vue?vue&type=style&index=0&id=e304b8fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e304b8fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e304b8fe')) {
      api.createRecord('e304b8fe', component.options)
    } else {
      api.reload('e304b8fe', component.options)
    }
    module.hot.accept("./navHeader.vue?vue&type=template&id=e304b8fe&scoped=true", function () {
      api.rerender('e304b8fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/new/navHeader.vue"
export default component.exports